<nb-card accent="primary" class="generated-password-dialog">
  <nb-card-header>Generiertes Passwort</nb-card-header>
  <nb-card-body>
    <p>Bitte notiere dieses Passwort jetzt — es wird nur einmal angezeigt. Der Benutzer muss es beim ersten Login ändern.</p>
    @if (userName) {
      <div class="user-name">Benutzername: <code>{{ userName }}</code></div>
    }
    <div class="password-box">
      <button nbButton outline status="primary" size="small" class="copy-button"
              [attr.aria-label]="copied() ? 'Passwort kopiert' : 'Passwort kopieren'" (click)="copy()">
        <nb-icon pack="eva" [icon]="copied() ? 'checkmark-outline' : 'copy-outline'"></nb-icon>
        {{ copied() ? 'Kopiert' : 'Kopieren' }}
      </button>
      <code class="password-value">{{ password }}</code>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="primary" (click)="close()">Verstanden</button>
  </nb-card-footer>
</nb-card>
